<template>
  <!-- :style="boxSize" -->
  <div
    class="wrapper"
    ref="scroller"
    @contextmenu.prevent="openMenu1"
    style="color: #eaf5eb"
  >
    <div v-if="historyLoding" @click="$emit('loadHistory')">
      {{ historyConfig.tip }}
    </div>
  
    <div class="scroller">
      <div class="web__main" ref="main">
        <div
          class="web__main-item"
          v-for="(item, index) in source === 0 ? saveList : list"
          :key="index"
          :class="{
            'web__main-item--mine': !simpleMode && item.mine,
            'web__main-item--sys': item.type === '1' || simpleMode,
            'web__main-item--simple': simpleMode,
          }"
        >
          <!-- 简约模式 -->
          <template v-if="simpleMode">
            <div
              v-if="item.type === '0'"
              class="simple-msg"
              :class="[simpleMsgClass(item), { 'simple-msg--mine': item.mine }]"
            >
              <div class="simple-meta">
                <span class="simple-name">{{ simpleDisplayName(item) }}</span>
                <span class="simple-date">{{ item.date }}</span>
                <span
                  class="simple-readed"
                  v-if="item.mine && item.status && item.status === 1"
                  >已读</span
                >
              </div>
              <div
                class="simple-body"
                @contextmenu.prevent.stop="openMenu2"
                :class="{
                  'simple-body--keyword': item.color == '1',
                  'simple-body--multi': item.color == '2',
                }"
              >
                <itemTalk
                  v-if="item.text.text"
                  @getChildText="getChildText"
                  :text="item.text.text"
                  :type="item.type"
                  :mine="item.mine"
                  :name="item.name"
                />
              </div>
            </div>
            <div
              v-else-if="item.type === '1'"
              class="simple-sys"
              @contextmenu.prevent.stop="openMenu2"
            >
              <span>{{ item.date }}-[提示] {{ item.text.text }}</span>
            </div>
          </template>

          <!-- 常规模式 -->
          <template v-else>
          <div v-if="item.type === '0'">
            <div class="web__main-user">
              <img
                v-if="item.mine"
                :src="item.avar"
                @click="bindClick('avar', item)"
              />
              <!-- 访客头像 -->
              <img
                v-if="!item.mine"
                :src="defaultAvatar"
                @click="bindClick('avar', item)"
              />

              <cite @click="bindClick('nickname', item)" class="nick_container">
                {{ item.name }}
                <i class="date_container">{{ item.date }}</i>
              </cite>
            </div>
            <i
              class="el-icon-warning msg-warn-icon"
              v-show="item.icon && item.mine"
            ></i>
            <div
              class="msg-row"
              :style="{ 'flex-direction': item.mine ? 'row' : 'row-reverse' }"
            >
              <el-radio
                v-model="item.isChecked"
                class="deepRadio"
                label="1"
                v-if="feedbackIsShow"
                @click.native.prevent="handleRadioClick(index, item.isChecked)"
                style="left: -22px"
              ></el-radio>
              <img
                src="../../../static/talks/msgError.png"
                alt=""
                width="20px"
                height="20px"
                v-if="item.sendStatus === 2"
              />
              <span
                class="readedMsg"
                v-if="item.mine && item.status && item.status === 1"
                >已读</span
              >
              <div
                class="web__main-text"
                @contextmenu.prevent.stop="openMenu2"
                :class="{
                  'web__main-text1': item.color == '1',
                  'web__main-text2': item.color == '2',
                  'web__main-text3':
                    item.color !== 1 &&
                    item.color !== 2 &&
                    item.name === '小贝',
                }"
              >
                <itemTalk
                  v-if="item.text.text"
                  @getChildText="getChildText"
                  :text="item.text.text"
                  :type="item.type"
                  :mine="item.mine"
                  :name="item.name"
                />
              </div>
            </div>
          </div>

          <div v-else-if="item.type === '1'">
            <div
              class="web__main-text web_main-systip"
              @contextmenu.prevent.stop="openMenu2"
            >
              <span style="font-weight: 400; color: #aaaaaa"
                >{{ item.date }}-[提示]-</span
              >
              <span style="font-weight: 400; color: #f85a5a">{{
                item.text.text
              }}</span>
            </div>
          </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <div class="downBtn" v-if="!isBottom" @click="scrollBottom">
			<span v-if="unread">{{unread}}</span>
		</div> -->
    <!-- <ul class="contextmenu" v-show="showMenu" :style="{left:left+'px',top:top+'px',width:'auto',zIndex:'99',height:'auto'}">
			<li style="height: 1.25rem;width: 3.75rem;">上移</li>
			<li style="height: 1.25rem;width: 3.75rem;">下移</li>
			<li style="height: 1.25rem;width: 3.75rem;">标签</li>
		</ul> -->

    <div
      class="contextmenu"
      v-show="menuVisible"
      :style="{ border: menuType == 1 && source === 0 ? 'none' : '' }"
    >
      <div
        class="contextmenu__item"
        v-show="menuType == 1"
        v-clipboard:copy="allText"
        v-clipboard:success="allTextCopy2"
        v-clipboard:error="onError"
      >
        全文复制
      </div>
      <div
        class="contextmenu__item"
        v-show="menuType == 2"
        v-clipboard:copy="copyText"
        v-clipboard:success="allTextCopy"
        v-clipboard:error="onError"
      >
        复制
      </div>
      <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        @click="updateMark"
      >
        备注
      </div>
      <!-- <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        @click="transformText"
      >
        翻译
      </div> -->
      <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        v-for="(item, index) in menuList"
        :key="index"
        @click="clickMenu(item)"
      >
        {{ item.name }}
      </div>
      <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        @click="handleFeedback"
        v-if="isNaN(Number(keyInfo.aduserId)) && keyInfo.aduserId !== ''"
      >
        反馈
      </div>
      <!-- v-if="isNaN(Number(keyInfo.aduserId)) && keyInfo.aduserId !== ''" -->

      <!-- <div class="contextmenu__item" v-show="menuType==2" @click="getWeChat(2)">转微</div>
			<div class="contextmenu__item" v-show="menuType==2" @click="getTel(2)">转电</div> -->
      <!-- <div class="contextmenu__item" v-show="menuType==2" @click="getQQ(2)">转QQ</div> -->
    </div>

    <el-dialog
      title="备注"
      :visible.sync="isShowMark"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input
        type="textarea"
        v-model="inputMark"
        placeholder="请输入备注"
        style="width: 100%"
        maxlength="40"
        show-word-limit
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowMark = false">取 消</el-button>
        <el-button type="primary" @click="updateMarkRequest">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Scroll from "@/utils/scroll";
import itemTalk from "./itemTalk";

export default {
  name: "JwChat_list",
  components: {
    itemTalk,
  },
  filters: {
    setWidth(value) {
      let width = value;
      if (`${value}`.match(/^\d+$/)) {
        width = value + "px";
      }
      return width;
    },
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => ({
        width: "100vw",
      }),
    },
    list: {
      type: Array,
      default: () => [],
    },
    feedback: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({
        width: "667px",
        height: "382px",
      }),
    },
    source: {
      type: Number,
      default: () => 0,
    },
    user: {},
    keyInfo: {
      type: Object,
      default: () => ({}),
    },
    simpleMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      load: false,
      scroll: null,
      scrollTimer: null,
      beforeTitle: "",
      titleTimer: "",
      loadHistory: false,
      historyLoding: false,
      // 快捷菜单
      menuVisible: false,
      top: 0,
      left: 0,
      menuType: 1,
      // 备注
      isShowMark: false,
      inputMark: "",
      allText: "",
      dataText: "",
      userInfo: {},
      userData: {},
      menuList: null,
      copyText: "",
      selectedText: "",
      saveList: [],
      feedbackIsShow: false,
      defaultAvatar: "",
    };
  },

  watch: {
    load(newval) {
      console.log("监听消息load", newval);
    },
    list: {
      handler(newval) {
        if (newval) {
          this.saveList = JSON.parse(JSON.stringify(newval));
          console.log("saveList:=====", this.saveList);
          // this.scrollBottom();
          this.feedbackIsShow = false;
          this.$nextTick(() => {
            setTimeout(() => {
              console.log("1111", this.saveList);
              console.log("this.scrollType ====", this.scrollType);
              let reset = false;
              if (this.historyLoding) {
                reset = true;
                this.closeTopTip();
                this.$nextTick(() => {
                  this.scroll.toBeforePosition();
                });
              }
              this.load = true;
              console.log("reset:", reset);
              this.childnodeLoad();
              console.log();
              if (this.$parent.isScolTop) {
                console.log("查看历史信息");
                this.scroll.scrollTo(0, 0, 200);
              } else {
                if (this.source === 0) {
                  console.log("不查看历史信息");
                  //this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
                }
              }
              if (reset) {
                this.scroll.resetTop();
              }
              //去掉滚到到底部
              if (this.scrollType === "scroll") {
                console.log("lallalll scrollBottom");
                this.scrollBottom();
              }
            }, 300);
          });
        }
      },
      deep: true,
    },
    // list(newval) {
    //   if (newval) {
    //     this.saveList = JSON.parse(JSON.stringify(newval));
    //     console.log("saveList:=====", this.saveList);
    //     // this.scrollBottom();
    //     this.feedbackIsShow = false;
    //     this.$nextTick(() => {
    //       console.log("-------------", this.saveList);
    //       setTimeout(() => {
    //         let reset = false;
    //         if (this.historyLoding) {
    //           reset = true;
    //           this.closeTopTip();
    //           this.$nextTick(() => {
    //             this.scroll.toBeforePosition();
    //           });
    //         }
    //         this.load = true;
    //         console.log("reset:", reset);
    //         this.childnodeLoad();
    //         console.log();
    //         if (this.$parent.isScolTop) {
    //           console.log("查看历史信息");
    //           this.scroll.scrollTo(0, 0, 200);
    //         } else {
    //           if (this.source === 0) {
    //             console.log("不查看历史信息");
    //             this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
    //           }
    //         }
    //         if (reset) {
    //           this.scroll.resetTop();
    //         }
    //         if (this.scrollType === "scroll") {
    //           this.scrollBottom();
    //         }
    //       }, 300);
    //     });
    //   }
    // },
    feedback(newVal) {
      this.feedbackIsShow = newVal;
      this.saveList = JSON.parse(JSON.stringify(this.list));
      if (this.feedback === false) {
        console.log(this.saveList);
        console.log(this.list);
        this.$emit("sendList", this.saveList);
      }
    },
    feedbackIsShow() {
      this.$emit("getFeedbackState", this.feedbackIsShow);
    },
    "config.scrollToButton"(newval) {
      if (newval) {
        console.log("config.scrollToButton")
        this.scrollBottom();
      }
    },
    unread(newval) {
      if (newval) {
        this.beforeTitle && this.resetTitle(this.beforeTitle);
        // this.saveTitle()
        // this.changeTitle()
        this.showBrowser();
      } else {
        // this.resetTitle(this.beforeTitle)
        this.resetTitle("智能客服");
      }
    },
    menuVisible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
    $route() {
      this.closeMenu();
    },

    autoTransfer(newVal, oldVal) {
      console.log("chatList watch autoTransfer00 newVal = ", newVal);
      console.log("chatList watch autoTransfer oldVal = ", oldVal);
      for (var i = 0; i < this.list.length; i++) {
        var chat = this.list[i];
        if (!chat.mine && chat.type === "0") {
          if (chat.text.text === newVal.message) {
            chat.color = "1";
          }
        }
      }

      this.dataText = newVal.content;
      if (newVal.type == 2) {
        this.getTel(1);
      } else if (newVal.type == 3) {
        this.getWeChat(1);
      } else if (newVal.type == 4) {
        this.getQQ(1);
      }
    },
    user(newVal, oldVal) {
      console.log("chatList watch user new = ", newVal);
      console.log("chatList watch user old = ", oldVal);
      this.userInfo = newVal;
    },
  },
  destroyed() {},
  computed: {
    boxSize() {
      let { height = "382px", width = "667px" } = this.config || {};
      if (`${height}`.match(/\d$/)) {
        height += "px";
      }
      if (`${width}`.match(/\d$/)) {
        width += "px";
      }
      const style = {
        height,
        width,
      };
      return style;
    },

    historyConfig() {
      const { historyConfig: { tip = "", activate = false } = {} } =
        this.config;
      return {
        tip,
        activate,
      };
    },
    isBottom() {
      return this.scroll && this.scroll.isBottom;
    },
    scrollType() {
      const { scrollType: type = "noroll" } = this.config;
      return type;
    },
    unread() {
      const { unread = 0 } = this.scroll || {};
      return unread;
    },

    autoTransfer() {
      console.log(
        "chatList computed autoTransfer",
        this.$store.state.iAutoChange
      );
      return this.$store.state.iAutoChange;
    },
  },

  methods: {
    isAgentMsg(item) {
      const name = (item && item.name) || "";
      return name === "小贝" || name.indexOf("智能体") !== -1;
    },
    simpleDisplayName(item) {
      if (this.isAgentMsg(item)) {
        return "[智能体]";
      }
      return item.name || "";
    },
    simpleMsgClass(item) {
      if (item.color == "1") {
        return "simple-msg--keyword";
      }
      if (item.color == "2") {
        return "simple-msg--multi";
      }
      if (this.isAgentMsg(item)) {
        return "simple-msg--agent";
      }
      if (item.mine) {
        return "simple-msg--cs";
      }
      return "simple-msg--visitor";
    },
    //默认头像
    async getDefaultAvatar() {
      var api = "/manager/sysconf/getCustDefaultPortrait";
      var res = await this.util.postRequest({
        url: api,
        data: {},
      });

      if (res.resultCode === "10000") {
        console.log("res getDefaultAvatar--", res.data);
        this.defaultAvatar = res.data;
      } else {
        this.$message.error(res.desc);
      }
    },
    handleRadioClick(index, item) {
      if (item === "0") {
        this.saveList[index].isChecked = "1";
      } else {
        this.saveList[index].isChecked = "0";
      }
      console.log("this.list[index].isChecked:", this.list[index].isChecked);
      this.$emit("sendList", this.saveList);
    },
    // 获取itemTalk组件传递的数据
    getChildText(data) {
      this.selectedText = data;
      console.log("子组件数据", data);
      console.log("选中的文字", this.selectedText);
    },
    scrollBottom() {
      console.log("scrollBottom", this.source);
      if (this.scroll) {
        this.scroll.refresh();
        setTimeout(() => {
          this.scroll.scrollTo(0, 0, 200);
          if (this.source !== 1) {
            this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
          } else {
            this.scroll.scrollTo(0, 0, 200);
          }
        }, 400);
      }
    },
    bindClick(type, data) {
      this.$emit("click", {
        type,
        data,
      });
    },
    createScroll() {
      // const that = this
      const dom = this.$refs.scroller;
      this.scroll = new Scroll(dom, {
        click: true,
        scrollbars: true,
        mouseWheel: true,
        preventDefault: false,
        interactiveScrollbars: true,
        hijackInternalLinks: true,
        // useTransform: false,
      });
      console.log("this.scroll", this.scroll);
      // copy code
      // dom.addEventListener(('ontouchstart' in window) ? 'touchstart' : 'mousedown', function(e) {
      // 	e.stopPropagation();
      // 	var target = e.target;
      // 	while (target.nodeType != 1) target = target.parentNode;
      // 	if (target.tagName === "SPAN") {
      // 		var clipBoardContent = target.innerText;
      // 		if (!clipBoardContent) return;
      // 		const input = document.createElement('input');
      // 		document.body.appendChild(input);
      // 		input.setAttribute('value', clipBoardContent);
      // 		input.select();
      // 		if (document.execCommand('copy')) {
      // 			document.execCommand('copy');
      // 			that.$message({
      // 				message: '复制成功',
      // 				type: 'success'
      // 			});
      // 		}
      // 		document.body.removeChild(input);
      // 	}
      // })

      // scroll done callback
      // this.scroll.on('scrollStart', function() {
      // 	console.log('chatList scroll on 11111')
      // 	// console.log('scroll')
      // 	that.scrollTop()
      // 	// that.scrollBottom()
      // 	if (that.historyLoding) return
      // 	console.log('chatList scroll on 2222')
      // 	that.scroll.savePosition()
      // 	that.scroll.read()
      // });
    },
    scrollTop() {
      const { isTop } = this.scroll;

      if (isTop) {
        if (this.loadHistory) {
          this.historyLoding = true;
        } else this.loadHistory = true;
        return;
      }
      this.closeTopTip();
    },
    closeTopTip() {
      this.loadHistory = false;
      this.historyLoding = false;
    },
    childnodeLoad() {
      if (this.scrollType === "scroll") return;
      const parent = this.$refs.main;
      if (!parent) return;
      // const childs = parent.children
      // console.log('chatList childnodeLoad childs = ', childs)
      // childs.forEach(i => {
      // 	const top = i.offsetTop
      // 	this.scroll.setPosition(top, i)
      // })
    },
    scrollRefresh() {
      setTimeout(() => {
        this.scroll && this.scroll.refresh();
        this.scrollRefresh();
      }, 0);
      return;
    },
    saveTitle() {
      const { title } = document;
      this.beforeTitle = title;
    },
    resetTitle(title) {
      console.log("chatList title = ", title);
      //document.title = title
      document.title = "智能客服";
      clearTimeout(this.titleTimer);
    },
    changeTitle() {
      const that = this;
      // let flage = 0;
      change();

      function change() {
        // let title = "【未读】"
        // if (flage) {
        // 	title = "【" + that.unread + "条】"
        // }
        // flage = !flage
        // that.titleTimer = setTimeout(() => {
        // 	that.resetTitle(title + that.beforeTitle)
        // 	change()
        // }, 1000);

        that.titleTimer = setTimeout(() => {
          that.resetTitle("智能客服");
          change();
        }, 1000);
      }
    },
    showBrowser() {
      // if (window.Notification && Notification.permission !== "denied") {
      // 	const {
      // 		unread
      // 	} = this
      // 	Notification.requestPermission(function(status) {
      // 		if (status === "granted")
      // 			new Notification('新消息', {
      // 				body: `您总共有${unread}条消息未读。`
      // 			});
      // 	});
      // }
    },
    // 快捷菜单方法
    openMenu1(e) {
      // console.log(e.clientX,e.clientY)
      console.log("类型：", this.menuType);

      if (this.source === 0) {
        this.loadAllText(0);
      } else {
        this.loadAllText(1);
      }
      this.menuType = 1;
      this.menuVisible = false;
      this.menuVisible = true;
      var menu = document.querySelector(".contextmenu");
      this.styleMenu(menu, e);
    },
    async openMenu2(e) {
      // 根据鼠标有无选中的值 复制文字
      console.log("keyname = ", this.$store.state.keyName);
      if(this.$store.state.keyName == '已离开' || this.$store.state.keyName == '在线访客列表') return;
      if (this.selectedText !== "") {
        this.copyText = this.selectedText;
      } else {
        this.copyText = e.target.innerText;
      }
      var api = "/manager/label/selectSystemLabelList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("chatList openMenu2 response = ", response.data);
      console.log("chatList openMenu2 response = ", response);
      if (response.resultCode === "10000") {
        this.menuList = response.data;
        this.dataText = e.target.innerText;
        this.menuType = 2;
        this.menuVisible = false;
        this.menuVisible = true;
        var menu = document.querySelector(".contextmenu");
        this.styleMenu(menu, e);
      } else {
        this.$message.error(response.desc);
      }
    },
    closeMenu() {
      this.menuVisible = false;
    },

    clickMenu(obj) {
      this.addLabel(obj);
    },

    styleMenu(menu, event) {
      if (!menu) return;
      if (menu.parentNode !== document.body) {
        document.body.appendChild(menu);
      }
      menu.style.position = "fixed";
      menu.style.zIndex = "99999";

      this.$nextTick(() => {
        const menuWidth = menu.offsetWidth || 100;
        const menuHeight = menu.offsetHeight || 120;
        let left = event.clientX;
        let top = event.clientY;

        if (left + menuWidth > window.innerWidth) {
          left = window.innerWidth - menuWidth - 4;
        }
        if (top + menuHeight > window.innerHeight) {
          top = Math.max(4, event.clientY - menuHeight);
        }

        menu.style.left = Math.max(4, left) + "px";
        menu.style.top = Math.max(4, top) + "px";
      });
    },
    async updateMarkRequest() {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }
      var api = "/manager/chat/customer/set/remark";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          remark: this.inputMark,
          sid: selected.sid,
        },
      });
      if (response.resultCode === "10000") {
        this.config.mark = this.inputMark;
        this.isShowMark = false;
      } else {
        this.$message.error(response.desc);
      }
    },
    allTextCopy(e) {
      console.log("复制", e.text);
      this.$store.state.copyText = e.text;
      // console.log("全文复制")
    },
    allTextCopy2(e) {
      console.log("全文复制2:", e.text);
      this.$store.state.copyText = e.text;
    },
    onError(e) {
      console.log(e);
    },
    transformText() {
      console.log("翻译该条消息");
    },
    updateMark() {
      this.$emit("updateMark", this.dataText);
    },
    handleFeedback() {
      console.log("客服反馈");
      this.feedbackIsShow = true;
    },
    // eslint-disable-next-line no-unused-vars
    addLabel(_obj) {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }
      // 接口调用已移除，直接执行成功后的流程
      // _obj 参数保留以保持接口一致性
      // console.log('1112222')
      // if (this.$store.state.keyName !== '我的同事') {
      // 	// this.$store.dispatch('autoChangeStatus', '2')
      // 	this.$store.state.selectedClient.labels.unshift(obj)
      // 	if (this.$store.state.selectedClient.labels.length > 5) {
      // 		this.$store.state.selectedClient.labels.pop()
      // 	}
      // } else {
      // 	this.$store.state.college.nowSelectClient.labels.unshift(obj)
      // 	if (this.$store.state.college.nowSelectClient.labels.length > 5) {
      // 		this.$store.state.college.nowSelectClient.labels.pop()
      // 	}
      // }
      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getWeChat(i) {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;

        if (i === 1) {
          return;
        }
      }

      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':3,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }
      if (this.$store.state.keyName !== "我的同事") {
        this.$store.dispatch("autoChangeStatus", "2");
      } else {
        if (this.$store.state.college.nowSelectClient.status < 2) {
          this.$store.state.college.nowSelectClient.status = "2";
        }
      }
      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getTel(i) {
      console.log("chatList getTel i = ", i);
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;

        if (i === 1) {
          return;
        }
      }

      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':2,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }
      if (this.$store.state.keyName !== "我的同事") {
        this.$store.dispatch("autoChangeStatus", "2");
      } else {
        if (this.$store.state.college.nowSelectClient.status < 2) {
          this.$store.state.college.nowSelectClient.status = "2";
        }
      }

      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getOrder(itemid) {
      console.log("chatList getOrder itemid = ", itemid);
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }

      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':2,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }

      if (itemid === "weiyuyue") {
        if (this.$store.state.keyName !== "我的同事") {
          this.$store.dispatch("autoChangeStatus", "3");
        } else {
          if (this.$store.state.college.nowSelectClient.status < 3) {
            this.$store.state.college.nowSelectClient.status = "3";
          }
        }
      } else if (itemid === "yuyue") {
        if (this.$store.state.keyName !== "我的同事") {
          this.$store.dispatch("autoChangeStatus", "4");
        } else {
          if (this.$store.state.college.nowSelectClient.status < 4) {
            this.$store.state.college.nowSelectClient.status = "4";
          }
        }
      }

      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getQQ(i) {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;

        if (i === 1) {
          return;
        }
      }
      // const QQReg = /[1-9]([0-9]{5,11})/
      // let QQ = this.dataText.replace(/\s|[(]|[)]|[（]|[）]|[-]*/g, '').match(QQReg)[0]
      
      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':4,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }
      // if (this.$store.state.keyName !== '我的同事') {
      // 	this.$store.dispatch('autoChangeStatus', '2')
      // } else {
      // 	this.$store.state.college.nowSelectClient.status = '2'
      // }

      if (this.$store.state.keyName !== "我的同事") {
        this.$store.dispatch("autoChangeStatus", "2");
      } else {
        if (this.$store.state.college.nowSelectClient.status < 2) {
          this.$store.state.college.nowSelectClient.status = "2";
        }
      }

      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },
    loadAllText(source) {
      if (source === 0) {
        this.getDetailRequest();
      } else {
        this.getAlltext();
      }
    },
    getAlltext() {
      console.log("this.list", this.list);
      this.allText = "";
      if (this.list != null) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].name != "") {
            this.allText =
              this.allText +
              this.list[i].name +
              " " +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          } else {
            this.allText =
              this.allText +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          }
        }
        // console.log(this.allText);
      }
    },
    // 获取用户信息
    async getDetailRequest() {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }
      var api = "/manager/chat/customer/detail";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          csid: this.util.getLocalId(),
          sid: selected.sid,
        },
      });
      // console.log("chatList getDetailRequest response = " , response)
      this.userData = response.data;
      this.initAlltext(this.userData);
    },
    initAlltext(userData) {
      this.allText = "";
      // this.allText = "昵称:" + userData.customerNickname
      let nickname =
        userData.customerNickname != null ? userData.customerNickname : "";
      let cid = userData.cid;
      let remark =
        userData.customerRemark != null ? userData.customerRemark : "";
      let keyword = userData.keyword ? userData.keyword : "无";
      let searchword = userData.query ? userData.query : "无";
      let source = userData.source == 1 ? "百度" : "";
      let labels = this.getLabels(userData.lastLabels);
      this.allText =
        "昵称:" +
        nickname +
        "\n" +
        "永久编号:" +
        cid +
        "\n" +
        "备注:" +
        remark +
        "\n" +
        "搜索词：" +
        searchword +
        "\n" +
        "关键词:" +
        keyword +
        "\n" +
        "来源:" +
        source +
        "\n" +
        "标签:" +
        labels +
        "\n";
      console.log("chatList initAlltext ", this.allText);
      if (this.list != null) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].name != "") {
            this.allText =
              this.allText +
              this.list[i].name +
              " " +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          } else {
            this.allText =
              this.allText +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          }
        }
      }
      //   this.$store.state.allText = this.allText;
    },
    getLabels(list) {
      let labels = "";
      if (list != []) {
        for (let i = 0; i < list.length; i++) {
          labels = labels != "" ? labels + " " + list[i].name : list[i].name;
        }
      } else {
        labels = "";
      }
      return labels;
    },
  },
  mounted() {
    this.getDefaultAvatar();
    console.log("首次进入chatList页面", this.defaultAvatar);

    this.scrollRefresh();
    this.createScroll();
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.closeMenu);
    this.closeMenu();
  },
};
</script>

<style>
.iScrollVerticalScrollbar.iScrollLoneScrollbar {
  z-index: 1 !important;
}

.contextmenu {
  z-index: 99999 !important;
}

.feedback {
  display: flex;
  justify-content: center;
}

.web__msg--img,
.web__msg--video,
.web__msg--file {
  position: relative;
  max-width: 250px;
  min-width: 200px;
  width: 100%;
  margin: 10px 0;
  border: 1px solid #eee;
  overflow: scroll;
  border-radius: 5px;
  cursor: pointer;
  display: block;
}

.web__msg--audio-player {
  display: block;
  width: 240px;
  max-width: 100%;
  margin: 8px 0;
  outline: none;
}

.web__msg--voice {
  display: inline-flex;
  align-items: center;
  min-width: 80px;
  max-width: 220px;
  padding: 8px 12px;
  margin: 4px 0;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.04);

  .voice-icon {
    font-size: 18px;
    margin-right: 8px;
    color: #333;
  }

  .voice-meta {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .voice-label {
    font-size: 13px;
    color: #333;
  }

  .voice-duration {
    font-size: 12px;
    color: #888;
  }

  .voice-error {
    font-size: 12px;
    color: #f56c6c;
  }

  &.is-playing .voice-icon {
    color: #07c160;
  }

  &.is-loading {
    opacity: 0.7;
    cursor: wait;
  }
}

/* .web__msg--img,
	.web__msg--video,
	.web__msg--file::-webkit-scrollbar{
		display: none;
	} */

.web__msg--img[data-class="iconBox"] {
  max-width: 24px;
  min-width: unset;
  border: none;
  margin: 0;
  vertical-align: bottom;
  display: inline-block;
}
</style>
<style scoped lang="scss">
.messageBox {
  display: flex;
  justify-content: flex-end;
  justify-items: center;
}

.deepRadio ::v-deep  {
  // position: absolute;
  // top: calc(50% - 7px);
  left: 0 !important;
  margin-right: 0 !important;
  .el-radio__label {
    display: none;
  }

  .el-radio__inner {
    margin-right: 0;
    // background-color: #1577d2;
    border-color: #1577d2;
  }

  .el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 2px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: inline-block;
    position: absolute;
    top: 0px;
    left: 0px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
}

.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}

.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  line-height: 1;
}

.wrapper :deep() .iScrollVerticalScrollbar.iScrollLoneScrollbar {
  z-index: 1 !important;
}

.downBtn {
  position: absolute;
  cursor: pointer;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  bottom: 2rem;

  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  &::before {
    content: "V";
    position: absolute;
    background: rgba(204, 204, 204, 0.2);
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    border-radius: 50%;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
  }

  span {
    background: #409eff;
    padding: 0.1rem 0.5rem;
    font-size: 0.7rem;
    border-radius: 0.5rem;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  // height: 28.125rem;
  overflow: hidden;
  // background-color: orange;

  /* Prevent native touch events on Windows */
  -ms-touch-action: none;

  /* Prevent the callout on tap-hold and text selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Prevent text resize on orientation change, useful for web-apps */
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -o-text-size-adjust: none;
  text-size-adjust: none;
}

.wrapper::-webkit-scrollbar {
  display: none;
}

// .chat_tip {
// 	width: 600px;
// 	height: 84px;
// 	background: rgba(0, 0, 0, 0.05);
// 	border-radius: 4px;
// }

.scroller {
  position: absolute;
  // width: calc(100% - 1.5rem);
  width: 92%;
  padding: 0.3125rem 1.875rem; //上10 右20 下10 左20

  /* Prevent elements to be highlighted on tap */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  /* Put the scroller into the HW Compositing layer right from the start */
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

.web__main-item {
  position: relative;
  font-size: 0;
  margin-bottom: 4px;
  padding-left: 54px;
  // max-height: 68px;
  // min-height: 40px;
  text-align: left;
  // background-color: cyan;
}

.web__main-user,
.web__main-text {
  display: inline-block;
  /* @css { * }display: inline;
    @css { * }zoom: 1; */
  vertical-align: top;
  @include change_size($font_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333334;
}

.web__main-user {
  position: absolute;
  cursor: pointer;
  left: 3px;
  // background-color: red;
}

.web__main-user img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 100%;
  transform: scaleX(-1);
}

.web__main-user cite {
  position: absolute;
  // left: 60px;
  top: -2px;
  /* width: 500px; */
  // line-height: 24px;
  font-size: 12px;
  white-space: nowrap;
  // color: #999;
  text-align: left;
  font-style: normal;
  padding-left: 10px;
}

.web__main-user cite i {
  padding-left: 15px;
  font-style: normal;
}

.web__main-text {
  max-width: 75%;
  position: relative;
  line-height: 1.25;
  // margin-top: 20px;
  // margin-left: 50px;
  padding: 1px 10px;
  // background-color: #f3f3f3;
  // border-radius: 3px;
  // border: 1px solid #f0f0f0;
  color: #5a9cf8;
  word-break: break-all;
  background: #f2f7ff;
  border-radius: 10px;
}

.systip_div {
  background-color: red;
  display: flex;
  flex-direction: column;
}

.web__main-sys {
  max-width: 90%;
  position: relative;
  line-height: 1.25;
  // margin-top: 25px;
  padding: 2px 10px;
  color: #5a9cf8;
  word-break: break-all;
  background: #f2f7ff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.web__main-arrow {
  top: 6px;
  left: -8px;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 8px;
  border-left-width: 0;
  border-right-color: #ebeef5;
}

.web__main-arrow::after {
  content: " ";
  top: -7px;
  left: 1px;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 7px;
  border-left-width: 0;
  border-right-color: #ebeef5;
}

.web__main-item--mine .web__main-text .web__main-arrow {
  left: auto;
  right: -5px;
  border-color: transparent;
  border-style: solid;
  border-width: 8px;
  border-right-width: 0;
  border-left-color: #409eff;
}

.web__main-item--mine .web__main-text .web__main-arrow::after {
  left: auto;
  right: -2px;
  border-color: transparent;
  border-style: solid;
  border-width: 7px;
  border-right-width: 0;
  border-left-color: #409eff;
}

.web__main-list {
  margin: 10px 0;
}

.web__main-list li {
  height: 30px;
  color: #409eff;
  line-height: 30px;
}

.msg-row {
  display: flex;
  align-items: flex-end;
  padding-top: 20px;
  justify-content: flex-end;
}

.msg-warn-icon {
  font-size: 14px;
  color: red;
  margin-top: 40px;
  margin-right: 5px;
}

.web__main-item--sys {
  padding-left: 0;
  padding-right: 0;
}

.web__main-item--mine {
  text-align: right;
  padding-left: 0;
  padding-right: 60px;
}

.web__main-item--mine .web__main-user {
  left: auto;
  right: 3px;
}

.web__main-item--mine .web__main-user cite {
  left: auto;
  right: 60px;
  text-align: right;
}

.web__main-item--mine .web__main-user cite i {
  padding-left: 0;
  padding-right: 15px;
}

.web__main-item--mine .web__main-text {
  margin-left: 0;

  text-align: left;
  background-color: #95ec69;
  color: #333334;
  border-radius: 10px;
  border: 1px solid #ececec;
}

/* 各字体档：气泡略压矮，仍可读 */
[data-size="2"] {
  .web__main-text,
  .web__main-sys {
    padding: 1px 10px;
    line-height: 1.25 !important;
  }
}
[data-size="3"] {
  .web__main-text,
  .web__main-sys {
    padding: 1px 10px;
    line-height: 1.3 !important;
  }
}
[data-size="4"] {
  .web__main-text,
  .web__main-sys {
    padding: 2px 10px;
    line-height: 1.35 !important;
  }
}
html[data-wide="1"] {
  .web__main-text,
  .web__main-sys {
    padding: 1px 10px;
  }
}

.web__main-text img {
  max-width: 200px;
}
.web__main-text3 {
  background-color: #fff !important;
  color: #000 !important;
}

.readedMsg {
  color: #8aa9d6;
  @include change_tip_size($tip_size_normal);
  flex-shrink: 0;
  margin: 0 6px 2px 0;
  line-height: 1;
  white-space: nowrap;
  align-self: flex-end;
}

.contextmenu__item {
  display: block;
  line-height: 34px;
  text-align: center;
}

.contextmenu__item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.contextmenu {
  position: fixed;
  background-color: #fff;
  width: 100px;
  /*height: 106px;*/
  font-size: 12px;
  color: #444040;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 99999;
}

.contextmenu__item:hover {
  cursor: pointer;
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.web_main-systip {
  background-color: rgba(51, 51, 52, 0) !important;
  padding-left: 0;
  margin-left: 0;
  margin-top: 0;
}

.web__main-text1 {
  background-color: #c588ff;
  color: #ffffff;
}

.web__main-text2 {
  background-color: #ff7e7e;
  color: #ffffff;
}

.nick_container {
  @include change_size($font_size_normal);
  color: gray;
}

html[data-compact="1"] {
  .scroller {
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
  }
  .web__main-item {
    padding-left: 32px;
    margin-bottom: 4px;
  }
  .web__main-item--mine {
    padding-left: 0;
    padding-right: 32px;
  }
  .web__main-item--sys {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 3px;
  }
  .web__main-item--mine .web__main-user cite {
    right: 32px;
  }
  .web__main-user cite {
    padding-left: 6px;
  }
  .web__main-user cite i {
    padding-left: 6px;
    padding-right: 6px;
  }
  .msg-row {
    padding-top: 18px;
  }
  .msg-warn-icon {
    margin-top: 30px;
  }
  .web__main-text,
  .web__main-sys {
    padding: 0 8px;
    line-height: 1.25;
  }
  .web_main-systip {
    padding: 1px 6px;
    line-height: 1.25;
  }
  .web__main-list {
    margin: 4px 0;
  }
  .web__msg--img,
  .web__msg--video,
  .web__msg--file {
    margin: 4px 0;
  }
  .web__msg--audio-player {
    margin: 4px 0;
  }
  .web__msg--voice {
    padding: 4px 8px;
    margin: 2px 0;
  }
}

/* 简约模式 */
.web__main-item--simple {
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: left !important;
  margin-bottom: 2px;
  min-height: 0;
  @include change_size($font_size_normal);
}

.simple-msg {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-left: 0;
  padding-left: 0;
  line-height: 1.2;
  word-break: break-all;
}

.simple-meta {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
}

.simple-name,
.simple-date {
  font-style: normal;
  font-weight: 500;
}

.simple-readed {
  @include change_tip_size($tip_size_normal);
  color: #8aa9d6;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.simple-body {
  width: 100%;
  margin-top: 1px;
  @include change_size($font_size_normal);
  color: #333334;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 1.25;
  background: transparent !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  max-width: 100% !important;
}

.simple-body ::v-deep .wrapper,
.simple-body ::v-deep .web__msg--audio,
.simple-body ::v-deep .showSpace {
  color: inherit;
  background: transparent !important;
}

.simple-msg--cs .simple-meta {
  color: #5a9cf8;
}

.simple-msg--mine {
  padding-left: 1.5rem;
  box-sizing: border-box;
}

.simple-msg--visitor .simple-meta {
  color: #3cb371;
}

.simple-msg--agent .simple-meta,
.simple-msg--agent .simple-body {
  color: #aaaaaa;
}

.simple-msg--keyword .simple-meta,
.simple-msg--keyword .simple-body,
.simple-body--keyword {
  color: #c588ff !important;
}

.simple-msg--multi .simple-meta,
.simple-msg--multi .simple-body,
.simple-body--multi {
  color: #ff7e7e !important;
}

.simple-sys {
  width: 100%;
  text-align: left;
  @include change_tip_size($tip_size_normal);
  color: #aaaaaa;
  line-height: 1.4;
  margin-left: 0;
  padding: 1px 0;
  font-family: PingFangSC-Regular, PingFang SC;
}

html[data-compact="1"] {
  .web__main-item--simple {
    margin-bottom: 1px;
  }
  .simple-msg--mine {
    padding-left: 1rem;
  }
}
</style>
